import React from 'react';

export const LiveGoodsMessaging = () => {
  return (
    <div className="fulfillment-message">
      <span>Is this in season? Check this plant&apos;s in-store availability and other details.</span>
    </div>
  );
};
